<div class="team-header">
  <h2 *ngIf="title" class="team-title">{{ header ? header : 'Team' }}</h2>
  <button
    (click)="openMemberModal()"
    [class.outline]="outlineButton"
    [class.filled]="!outlineButton"
    *ngIf="enableAddMember"
    class="invite-member"
  >
    <span inlineSVG="/assets/icons/user-plus.svg"></span>
    Add Member
  </button>
</div>

<p class="subheading" *ngIf="subheading">{{ subheading }}</p>

<ng-container *ngIf="members?.length > 0; else missingTeamMembers">
  <fl-collection-table
    [columnSettings]="columnSettings"
    [compact]="compact"
    [dataSourceData]="members"
    [unpadded]="unpadded"
  ></fl-collection-table>
</ng-container>

<ng-template #missingTeamMembers>
  <h4 class="missing-members">There are no team members for this entity.</h4>
</ng-template>
